// SPDX-License-Identifier: AGPL-3.0-or-later

import crownUrl from '@app/media/images/micup-premium-badge.png';
import oneMonthUrl from '@app/media/images/premium/package/1-ay.webp';
import threeMonthUrl from '@app/media/images/premium/package/3-ay.webp';
import twelveMonthUrl from '@app/media/images/premium/package/12-ay.webp';
import {PublicUserFlags} from '@fluxer/constants/src/UserConstants';

// 0: the single package badge of packages bought after the tiers closed.
export type PremiumPackageMonths = 0 | 1 | 3 | 12;

// Micup: the one Plus crown every member wears, whatever brought the Plus; the premium and shop pages show the same
// file. Swapping this file changes the crown everywhere.
export const premiumBadgeUrl = (): string => crownUrl;

// The package badges: silver, blue and gold infinity; the single badge wears the silver one until it has its own art.
// Swapping a file changes the design; the code stays as is.
const PACKAGE_BADGE_URLS: Record<PremiumPackageMonths, string> = {
	0: oneMonthUrl,
	1: oneMonthUrl,
	3: threeMonthUrl,
	12: twelveMonthUrl,
};

export const premiumPackageBadgeUrl = (months: PremiumPackageMonths): string => PACKAGE_BADGE_URLS[months];

// The largest paid package the same bits carry, kept after Plus ends (unlike the crown, which needs PREMIUM_BADGE);
// null without one.
export function premiumPackageMonths(flags: number): PremiumPackageMonths | null {
	if (flags & PublicUserFlags.PREMIUM_BADGE_GOLD) return 12;
	if (flags & PublicUserFlags.PREMIUM_BADGE_BLUE) return 3;
	if (flags & PublicUserFlags.PREMIUM_BADGE_WHITE) return 1;
	if (flags & PublicUserFlags.PREMIUM_BADGE_SINGLE) return 0;
	return null;
}
